import { getCookie } from "../utils/Cookies";
import { lazyLoad } from "../utils/LazyLoad";

const CACHE_KEY = 'LazyLastViewed';

export const LazyLastViewed = (excludeId: string) => ({
    html: '',
    loading: true,
    count: 0,

    init() {
        const cookie = getCookie('LastViewedOffers');
        if (!cookie) return;

        const allIds = decodeURIComponent(cookie).split(';').filter(Boolean);
        const visibleIds = allIds.filter(id => id !== excludeId);
        if (!visibleIds.length) return;

        this.count = Math.min(visibleIds.length, 4);

        const el = this.$el as HTMLElement;
        for (let i = this.count; i < 4; i++) {
            el.querySelector(`[data-skeleton-item="${i}"]`)?.remove();
        }

        const cacheId = allIds.join(';');
        const removeSkeleton = () => this.$nextTick(() => el.querySelector('[data-skeleton]')?.remove());

        const applyHtml = (html: string) => {
            if (excludeId) {
                const temp = document.createElement('div');
                temp.innerHTML = html;
                temp.querySelector(`[data-offer-id="${excludeId}"]`)?.remove();
                this.html = temp.innerHTML;
            } else {
                this.html = html;
            }
            this.loading = false;
            removeSkeleton();
        };

        // Check sessionStorage cache (keyed by all cookie IDs, exclude handled client-side)
        try {
            const cached = sessionStorage.getItem(CACHE_KEY);
            if (cached) {
                const data = JSON.parse(cached);
                if (data.key === cacheId && data.html) {
                    applyHtml(data.html);
                    return;
                }
            }
        } catch {}

        // Always fetch without exclude — cache the full set
        lazyLoad(el, '/wp-json/entries/last-viewed', {
            onSuccess: (html) => {
                if (!html) {
                    this.count = 0;
                    this.loading = false;
                    return;
                }
                try {
                    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ key: cacheId, html }));
                } catch {}
                applyHtml(html);
            },
            onError: () => {
                this.count = 0;
                this.loading = false;
            }
        });
    }
});
